import React from 'react';
import Header from '../components/ui/Header';
import { Outlet } from 'react-router-dom';
import { PlayerSheetProvider } from '../components/playerSheet/PlayerSheetContext';

interface MainProps {
  onLogout: () => void;
}

const Main: React.FC<MainProps> = ({ onLogout }) => (
  <PlayerSheetProvider>
    <div className="min-h-screen w-full max-w-full bg-gradient-to-b from-white to-blue-100 flex flex-col">
      <Header onLogout={onLogout} />
      <div className="flex-1 flex flex-col items-center w-full min-w-0">
        <Outlet />
      </div>
      <footer className="w-full bg-white border-t border-gray-200 py-4 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-sm text-gray-500">© 2026 Sports Data Partners, LLC dba STATDOG. All rights reserved.</p>
        </div>
      </footer>
    </div>
  </PlayerSheetProvider>
);

export default Main;
